import { render, staticRenderFns } from "./publish-layer-status-list.vue?vue&type=template&id=13106cd8&scoped=true"
import script from "./publish-layer-status-list.vue?vue&type=script&lang=js"
export * from "./publish-layer-status-list.vue?vue&type=script&lang=js"
import style0 from "./publish-layer-status-list.vue?vue&type=style&index=0&id=13106cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13106cd8",
  null
  
)

export default component.exports